<div class="rounded-base">
    @if (expandable) {
    <div class="relative w-full">
        <i (click)="openModel()"
            class="pi pi-arrow-up-right-and-arrow-down-left-from-center absolute right-2 top-2 text-xs cursor-pointer p-1 border rounded-base bg-white shadow-md"></i>
    </div>
    }

    @if (data) {
    <div class="pt-8 w-full h-full">
        <div echarts [options]="data" [class]="customStyles ? customStyles : 'h-[20rem]  lg:h-[25rem]  xl:h-[25rem]'">
        </div>
    </div>
    }
</div>

@if (data) {
<app-dialog [visible]="OpenGraphDialog" [showCloseButton]="true" [fullscreenOnMobile]="true"
    class="max-w-[50%]" (closed)="OpenGraphDialog = false">
    <ng-template #bodyTemplate>
        <div class="p-4">
            <div echarts [options]="data" class="w-full h-[15rem] lg:h-[25rem]"></div>
        </div>
    </ng-template>
</app-dialog>
}